/**
 * Gen2 config shim. The Gen1 ConfigureApp + appClientsConfig approach is gone —
 * Amplify is now configured from amplify_outputs.json in ./initAmplify.ts.
 *
 * This keeps the ConfigureAmplify(provider, isExtension) entry point that the
 * SAML / websocket login flow (AuthContainer.handleSaml) still calls. Under Gen2
 * the config is a single source (one user pool / app client from the outputs),
 * so provider/isExtension no longer select a per-provider app client — they're
 * retained for call-site compatibility and logging.
 */
import { configureAmplify } from "./initAmplify";

export function ConfigureAmplify(provider?: string, isExtension?: boolean) {
  console.log("configuring amplify (gen2)", { provider, isExtension });
  configureAmplify();
}
